import axios from "axios";

// Base axios client for API requests
// Uses REACT_APP_API_BASE from environment variables
// Base URL includes /api/v1/public for public endpoints
const getBaseURL = () => {
  const apiUrl = process.env.REACT_APP_API_BASE || "http://localhost:3000";
  // Remove trailing slash if present to avoid double slashes
  const normalizedUrl = apiUrl.replace(/\/+$/, "");
  return `${normalizedUrl}/api/v1/public`;
};

const client = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor (add auth tokens here if needed)
client.interceptors.request.use(
  (config) => {
    // Add auth token from localStorage if it exists
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor (handle errors globally if needed)
client.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle global errors here if needed
    return Promise.reject(error);
  }
);

export default client;
